module.exports = __webpack_public_path__ + "img/icon-supplier-conversations-selected.2f8de689.svg";